<template>
  <v-list>
    <div v-for="(program, index) in programs">
      <v-divider v-if="index > 0"/>
      <v-subheader v-text="program" />
      <v-list-item v-for="item in filterByProgram(crts,program)" dense>
        <v-list-item-content>
          <v-list-item-title>
            <a :href=" `/securities/${item.cusip}`" v-text="item.deal_name"></a>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>        
    </div>
  </v-list>
</template>
<script>
function uniq(value,index,self) {
  return self.indexOf(value) === index
}

export default {
  props: {
    limit: {
      default: null,
      type: Number
    }
  },
  methods: {
    filterByProgram: function(array,program) {
      return array.filter(item => item.program == program)
    }
  },
  computed: {
    crts() {
      return this.crtList.slice(0,this.limit ? this.limit : this.crtList.length)
    },
    programs() {
      return this.crts.map(item => item.program).filter(uniq)
    },
  },
  data: () => ({
    listGroup: [],
    crtList: [
      {
        "cusip": "20754WAC9",
        "cusip_count": 3,
        "agency": "FNM",
        "program": "CAS",
        "deal_name": "2020-R02"
      },
      {
        "cusip": "20753KAF9",
        "cusip_count": 3,
        "agency": "FNM",
        "program": "CAS",
        "deal_name": "2019-R02"
      },
      {
        "cusip": "35563KBE9",
        "cusip_count": 4,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2019-DNA1"
      },
      {
        "cusip": "35564LBE6",
        "cusip_count": 4,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2019-DNA2"
      },
      {
        "cusip": "35564TBE9",
        "cusip_count": 4,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2019-DNA3"
      },
      {
        "cusip": "35565ABE9",
        "cusip_count": 4,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2019-DNA4"
      },
      {
        "cusip": "35564PAC2",
        "cusip_count": 1,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2019-FTR1"
      },
      {
        "cusip": "35564WBE2",
        "cusip_count": 4,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2019-FTR2"
      },
      {
        "cusip": "35565EAE2",
        "cusip_count": 1,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2019-FTR3"
      },
      {
        "cusip": "35565GAE7",
        "cusip_count": 1,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2019-FTR4"
      },
      {
        "cusip": "35563MBE5",
        "cusip_count": 4,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2019-HQA1"
      },
      {
        "cusip": "35564MBE4",
        "cusip_count": 4,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2019-HQA2"
      },
      {
        "cusip": "35564XBE0",
        "cusip_count": 4,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2019-HQA3"
      },
      {
        "cusip": "35565CBE5",
        "cusip_count": 4,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2019-HQA4"
      },
      {
        "cusip": "35564RCC6",
        "cusip_count": 5,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2019-HRP1"
      },
      {
        "cusip": "35565HBE4",
        "cusip_count": 4,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2020-DNA1"
      },
      {
        "cusip": "35565KBE7",
        "cusip_count": 4,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2020-DNA2"
      },
      {
        "cusip": "35565WBE1",
        "cusip_count": 4,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2020-DNA3"
      },
      {
        "cusip": "35565XBE9",
        "cusip_count": 4,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2020-DNA4"
      },
      {
        "cusip": "35566ABE8",
        "cusip_count": 4,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2020-DNA5"
      },
      {
        "cusip": "35566CBE4",
        "cusip_count": 4,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2020-DNA6"
      },
      {
        "cusip": "35565JBE0",
        "cusip_count": 4,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2020-HQA1"
      },
      {
        "cusip": "35565LBE5",
        "cusip_count": 4,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2020-HQA2"
      },
      {
        "cusip": "35565MBE3",
        "cusip_count": 4,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2020-HQA3"
      },
      {
        "cusip": "35565RBE2",
        "cusip_count": 4,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2020-HQA4"
      },
      {
        "cusip": "35565TBE8",
        "cusip_count": 4,
        "agency": "FHL",
        "program": "STACR",
        "deal_name": "2020-HQA5"
      }
    ]

  })
}
</script>
<style scoped>
.v-list-item__content {
  padding: 0px;
}
</style>